module.exports = __webpack_public_path__ + "img/reports_debits.4aab3da3.png";